import {
  formatDepositAmount,
  formatDepositDate,
  formatDepositAccountType,
  getDepositTitle,
  normalizeDeposit,
} from './depositHelpers';

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function openDepositReceipt(rawDeposit) {
  const deposit = normalizeDeposit(rawDeposit);
  if (!deposit) return;

  const title = getDepositTitle(deposit);
  const amountLabel = formatDepositAmount(deposit.amount, deposit.currency);
  const dateLabel = formatDepositDate(deposit.creditedAt || deposit.requestedAt);
  const statusLabel = String(deposit.status || '—');
  const accountLabel = deposit.accountType
    ? formatDepositAccountType(deposit.accountType) || deposit.accountType
    : null;

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Deposit ${escapeHtml(deposit.id)}</title>
  <style>
    body { font-family: system-ui, -apple-system, sans-serif; color: #0b1929; margin: 40px; }
    h1 { font-size: 20px; margin: 0 0 8px; }
    .muted { color: #3d5a73; font-size: 13px; margin-bottom: 24px; }
    .row { display: flex; justify-content: space-between; padding: 10px 0; border-bottom: 1px solid #e8f1f8; font-size: 14px; }
    .label { color: #7a9ab5; }
    .value { font-weight: 600; }
    .amount { color: #1a7f5a; font-size: 22px; font-weight: 700; margin: 18px 0 28px; }
  </style>
</head>
<body>
  <h1>Deposit confirmation</h1>
  <div class="muted">${escapeHtml(title)} · ${escapeHtml(dateLabel)}</div>
  <div class="amount">${escapeHtml(amountLabel)}</div>
  <div class="row"><span class="label">Status</span><span class="value">${escapeHtml(statusLabel)}</span></div>
  ${
    accountLabel
      ? `<div class="row"><span class="label">Account type</span><span class="value">${escapeHtml(accountLabel)}</span></div>`
      : ''
  }
  <div class="row"><span class="label">Currency</span><span class="value">${escapeHtml(deposit.currency)}</span></div>
  <div class="row"><span class="label">Deposit ID</span><span class="value">${escapeHtml(deposit.id)}</span></div>
  <div class="row"><span class="label">Provider</span><span class="value">${escapeHtml(deposit.provider || 'Noah')}</span></div>
  <script>window.onload = function () { window.print(); };</script>
</body>
</html>`;

  const win = window.open('', '_blank');
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
}
